export const data = {
    en: {
      paragraphs: [
        {
          title: 'Educators',
          text: 'Vocational training for vocational teachers takes center stage and takes place on the basis of didactic approaches. The goal of teacher training is to design the teaching and learning processes in an action-oriented way, to use modern training methods, to strengthen independent and cooperative learning and, above all, to put one-sided teacher activities (teacher lectures, which activate learners only slightly) into the background.',
        },
        {
          title: 'Training for the students',
          text: 'We organize for one to two years continuing education in Germany for Chinese graduates of vocational schools and vocational colleges so that they can further develop their vocational competence.',
        },
      ],
    },
    de: {
      paragraphs: [
        {
          title: 'Lehrerfortbildung',
          text: 'Neben der Unterstützung beim Aufbau dualer Ausbildungsstrukturen ist die Berufsschullehrerfortbildung ein weiterer Schwerpunkt der Institutstätigkeit. Die Ausbildung der Lehrkräfte erfolgt auf der Grundlage von geschäfts- und arbeitsprozessorientierten Lehrplänen, auf der Basis moderner fachdidaktischer Ansätze und orientiert sich an der Berufsschullehrerausbildung in Deutschland. Wichtige Ziele sind dabei, dass die Lehrkräfte nach Ihrer Fortbildung, curriculare Arbeiten durchführen und Lehr- und Lernprozesse handlungsorientiert konzipieren können, moderne Ausbildungsmethoden einsetzen, den Schülerinnen und Schülern selbstständiges und kooperatives Lernen ermöglichen, um deren berufliche Handlungskompetenz zu stärken.',
        },
        {
          title: 'Fortbildung für die Schüler',
          text: 'Wir organisieren für chinesische Absolventen von Berufsschulen und Berufscolleges für ein bis zwei Jahre Fortbildung in Deutschland, damit sie ihre berufliche Handlungskompetenz weiterentwickeln können.',
        },
      ],
    },
};